module.exports = __webpack_public_path__ + "static/Circo-df92b25113acfc2f44b49ec245c736fd.jpg";